import { CaseReducer, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AuthResponse } from '../schemas/auth.schemas';

interface PublicUserState {
  role: 'public';
}

export type LoggedInUserState = AuthResponse['user'] & {
  tokens: AuthResponse['tokens'];
};

// export interface LoggedInUserState {
//   tokens: AuthResponse['tokens'];
// }

type UserState = PublicUserState | LoggedInUserState;

const initialState: PublicUserState = {
  role: 'public',
};

const logoutReducer: CaseReducer<UserState> = () => {
  return initialState;
};

export const userSlice = createSlice({
  name: 'user',
  initialState: initialState as UserState,
  reducers: {
    logout: logoutReducer,
    setCredentials: (state, { payload }: PayloadAction<AuthResponse>) => {
      if (!payload.user || !payload.tokens) return state;
      return {
        ...payload.user,
        tokens: payload.tokens,
      };
    },
  },
});

// Action creators are generated for each case reducer function
export const { logout, setCredentials } = userSlice.actions;

export default userSlice.reducer;
